import React from 'react';
import { Box, Text, SimpleGrid, FormControl, Input, Select } from '@chakra-ui/react';
import RefundFormLabel from './RefundFormLabel';
import { BANK_ACCOUNT_TYPE_OPTIONS } from 'api/administrador/refunds';

const PURPLE = '#574feb';

const inputStyles = {
  size: 'sm',
  borderColor: 'gray.300',
  _focus: { borderColor: PURPLE, boxShadow: `0 0 0 1px ${PURPLE}` },
};

export default function BankDetailsForm({ values, onChange, isDisabled = false }) {
  const setField = (field) => (e) => onChange({ [field]: e.target.value });

  return (
    <Box border="1px solid" borderColor="gray.200" borderRadius="md" p={4} bg="white">
      <Text fontSize="xs" fontWeight="bold" color={PURPLE} letterSpacing="wider" textTransform="uppercase" mb={4}>
        Datos bancarios destino
      </Text>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <FormControl isRequired>
          <RefundFormLabel required>Titular</RefundFormLabel>
          <Input
            {...inputStyles}
            placeholder="Nombre del titular"
            value={values.bank_holder}
            onChange={setField('bank_holder')}
            isDisabled={isDisabled}
          />
        </FormControl>

        <FormControl isRequired>
          <RefundFormLabel required>Documento</RefundFormLabel>
          <Input
            {...inputStyles}
            placeholder="Ej: 80.234.567"
            value={values.bank_document}
            onChange={setField('bank_document')}
            isDisabled={isDisabled}
          />
        </FormControl>

        <FormControl isRequired>
          <RefundFormLabel required>Banco</RefundFormLabel>
          <Input
            {...inputStyles}
            placeholder="Ej: Bancolombia"
            value={values.bank_name}
            onChange={setField('bank_name')}
            isDisabled={isDisabled}
          />
        </FormControl>

        <FormControl isRequired>
          <RefundFormLabel required>Tipo</RefundFormLabel>
          <Select
            {...inputStyles}
            placeholder="Selecciona tipo"
            value={values.bank_account_type}
            onChange={setField('bank_account_type')}
            isDisabled={isDisabled}
          >
            {BANK_ACCOUNT_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl isRequired gridColumn={{ md: 'span 2' }}>
          <RefundFormLabel required>Número de cuenta</RefundFormLabel>
          <Input
            {...inputStyles}
            placeholder="Número de cuenta"
            value={values.bank_account_number}
            onChange={setField('bank_account_number')}
            isDisabled={isDisabled}
          />
        </FormControl>
      </SimpleGrid>
    </Box>
  );
}
